module.exports = __webpack_public_path__ + "media/images/mypage/mypage_t4-50da99bc6ba799eb2ed7d28fe6819c18.gif";